import AnchorScript from "./AnchorScript";

export default AnchorScript;
